module.exports = __webpack_public_path__ + "img/tweet-content.e9a7f1e5.png";